module.exports = __webpack_public_path__ + "img/event_new.3a7d8ff1.png";